import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled, Typography } from '@mui/material';

import { getPctgColor } from '»utils/pctgColors';

export const TdSmallStyled = styled('td')(() => ({
  padding: '0px',
  width: '40px',
}));

export const VariationStyle = styled('div')(({
  value,
  hasVisualEffectAttr,
}) => {
  const getVariationChar = () => {
    if (value !== 'NaN') {
      if (value > 0) return '"+"';

      if (value === 0) return '""';
    }
    return '""';
  };
  return {
    '&::before': {
      content: hasVisualEffectAttr ? getVariationChar() : '""',
    },
  };
});

export const FontAwesomeIconStyled = styled(FontAwesomeIcon, {
  shouldForwardProp: (prop) => prop !== 'value',
})(({ theme, value }) => ({
  color: getPctgColor(value, theme),
  fontSize: 16,
  marginLeft: 4,
}));

export const wrapperFlag = styled('div')(() => ({
  display: 'flex',
}));

export const EyeIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  color: theme.palette.colors.mainFocused,
  fontSize: '16px',
}));

export const ValueZeroStyled = styled('span')(() => ({
  fontFamily: 'Roboto Mono',
  fontWeight: 500,
}));

export const UppercaseLabel = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '12px',
  textTransform: 'uppercase',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
}));

export const UppercaseCell = styled('td', {
  shouldForwardProp: (prop) =>
    prop !== 'dataItem' && prop !== 'render' && prop !== 'title',
})(() => ({
  textTransform: 'uppercase',
}));

export const CustomTableCell = styled('td', {
  shouldForwardProp: (prop) =>
    prop !== 'isSelected' &&
    prop !== 'dataIndex' &&
    prop !== 'rowType' &&
    prop !== 'columnsCount' &&
    prop !== 'columnIndex' &&
    prop !== 'selectionChange' &&
    prop !== 'dataItem' &&
    prop !== 'ariaColumnIndex' &&
    prop !== 'render' &&
    prop !== 'title',
})(() => ({}));
